import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./EnergySavingCTA.module.scss";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { EnergyLabelsResponse } from "../../data/EnergyLabelsFetcher";
import { EnergyLabelResult } from "../../data/energyLabelResponseSchema";
import { Variant } from "@/types/types";
import classnames from "classnames/bind";
import {
  energyDescriptionMap,
  FALLBACK_MEDAL_URL,
  getEnergyLabelResult,
  RATING_NOT_POSSIBLE,
  ratingMedalMap,
} from "../../utils";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

const cx = classnames.bind(styles);

type Props = {
  onClick: () => void;
  variant: Variant;
  energyLabelsResponse: EnergyLabelsResponse;
};

function getTitle(result: EnergyLabelResult | null) {
  if (!result) return "";

  const { energyCostSavingUnformatted = 0, energyCostSaving = "" } = result;

  if (!energyCostSavingUnformatted) {
    return "No energy saving";
  }

  return `${energyCostSaving} energy saving`;
}

function getDescription(result: EnergyLabelResult | null) {
  if (!result) return "";

  const { numberOfAlternatives = 0, medalRatingText = "" } = result;

  if (numberOfAlternatives > 0) {
    return (
      <>
        Found{" "}
        <span className={styles.energySavingCTA__alt}>
          {numberOfAlternatives}
        </span>{" "}
        cheaper to run
      </>
    );
  }

  return (
    energyDescriptionMap[medalRatingText.toLowerCase()] || RATING_NOT_POSSIBLE
  );
}

function getMedalURL(result: EnergyLabelResult | null) {
  if (!result) return FALLBACK_MEDAL_URL;
  const { medalRatingText = "" } = result;

  return ratingMedalMap[medalRatingText.toLowerCase()] || FALLBACK_MEDAL_URL;
}

export function EnergySavingCTA({
  energyLabelsResponse,
  variant,
  onClick,
}: Props) {
  const result = getEnergyLabelResult(energyLabelsResponse, variant);
  const hasError =
    energyLabelsResponse.error || !energyLabelsResponse.results || !result;

  return (
    <div
      className={cx("energySavingCTA", {
        ["energySavingCTA--hidden"]: hasError,
      })}
    >
      {!hasError && (
        <SecondaryButton
          className={styles.energySavingCTA__container}
          onClick={onClick}
        >
          <div className={styles["energySavingCTA__medal"]}>
            <img
              src={formatAmplienceImageURL(getMedalURL(result))}
              alt={`${result?.medalRatingText || ""} rating`}
            />
          </div>
          <div className={styles["energySavingCTA__body"]}>
            <div className={styles["energySavingCTA__title"]}>
              {getTitle(result)}
            </div>
            <div className={styles["energySavingCTA__subtitle"]}>
              {getDescription(result)}
            </div>
          </div>
          <ChevronRight size="medium" />
        </SecondaryButton>
      )}
    </div>
  );
}

export default EnergySavingCTA;
